import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  // Get Sentry configuration from runtime config
  const sentryDsn = config.public.sentryDsnUrl
  const environment = config.public.sentryEnvironment

  // Skip Sentry initialization in emulator/development mode to avoid conflicts
  const isEmulator = environment === 'emulator' || environment === 'development'

  if (isEmulator) {
    console.log('Skipping Sentry initialization in emulator/development mode')
    return
  }

  if (!sentryDsn) {
    console.warn('Sentry DSN not configured, skipping initialization')
    return
  }

  Sentry.init({
    environment,
    Vue: nuxtApp.vueApp,
    dsn: sentryDsn,
    initialScope: {
      tags: {
        context: 'client',
        package: 'monocle-gallery',
      },
    },
    integrations: [Sentry.replayIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost'],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    autoSessionTracking: false,
    sendClientReports: false,
  })
})
